import { gql, useLazyQuery, useMutation, useQuery } from '@apollo/client'
import { Destination } from '@ui/__generated__/graphql'

const GetDestinationsQL = gql(`
  query GetDestinations {
    destinations {
      id
      name
      formData
      template {
        id
        name
        slug
        description
        type
      }
      pipelines {
        id
        name
      }
    }
  }
`)

const GetDestinationQL = gql(`
  query GetDestination($input: FindByIdInput!) {
    destination(input: $input) {
      formData
      id
      name
      template {
        id
        name
        slug
        description
        type
      }
    }
  }
`)

const CreateDestinationQL = gql(`
  mutation CreateDestination($input: CreateDestinationInput!) {
    createDestination(input: $input) {
      formData
      id
      name
      template {
        id
        name
        slug
        description
        type
        code
      }
    }
  }  
`)

const UpdateDestinationQL = gql(`
  mutation UpdateDestination($input: UpdateDestinationInput!) {
    updateDestination(input: $input) {
      id
      name
      formData
    }
  }
`)

const DeleteDestinationQL = gql(`
  mutation DeleteDestination($input: DeleteDestinationInput!) {
    deleteDestination(input: $input)
  }
`)

const ValidateDestinationQL = gql(`
  query ValidateDestination($input: ValidateDestinationInput!) {
    validateDestination(input: $input) {
      success
    }
  }
`)

export const GetDestinationsQuery = () => {
  return useQuery<{ destinations: Destination[] }>(GetDestinationsQL, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  })
}

export const GetDestinationQuery = (id?: string) => {
  return useQuery(GetDestinationQL, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        id,
      },
    },
    skip: !id,
  })
}

export const ValidateDestinationLazyQuery = () => {
  return useLazyQuery(ValidateDestinationQL, {
    fetchPolicy: 'network-only',
  })
}

export const CreateDestinationQuery = () => {
  return useMutation(CreateDestinationQL)
}

export const UpdateDestinationQuery = () => {
  return useMutation(UpdateDestinationQL)
}

export const DeleteDestinationQuery = () => {
  return useMutation(DeleteDestinationQL)
}
